const Welcome = () => {
    return (
        <h1>LumberHacking's Guide for Bloodline: Heroes of Lithas</h1>
    )
}

export default Welcome;